import { getTextWidthAndHeight } from "../../helper/getTextWidth";

class ConnectionPlot {
  constructor(props) {
    const { id, width, height, paths, font, grid, unitSize } = props;
    this.id = id;
    this.width = width;
    this.height = height;
    this.paths = paths || [];
    this.ctx = this.initCtx(id);
    this.gridWidth = unitSize;
    this.gridHeight = unitSize;
    this.unitSize = unitSize;
    this.font = font || 12;
    this.grid = grid || false;
    this.virtualCanvas = document.createElement("canvas");
    //#87CEEB
  }

  initCtx = (id) => {
    const { width, height } = this;
    let canvas = document.getElementById(id);
    const virtualCanvas = document.createElement("canvas");
    virtualCanvas.width = width || canvas.width;
    virtualCanvas.height = height || canvas.height;
    this.virtualCanvas = virtualCanvas;
    const ctx = virtualCanvas.getContext('2d');
    ctx.lineWidth = 4;
    ctx.font = `normal ${this.font}px Arial`;
    ctx.fillStyle = '#000000';
    this.netName = [];
    this.verticals = [];
    this.dashedLines = [];
    return ctx;
  }

  clear = () => {
    const { ctx, width, height, id } = this;
    ctx && ctx.clearRect(0, 0, width, height);
    this.ctx = this.initCtx(id);
    let canvas = document.getElementById(id);
    if (canvas) {
      canvas.width = width;
    }
  }

  reset = ({ width, height }) => {
    this.clear();
    this.ctx = this.initCtx(this.id);
    this.width = width;
    this.height = height;
  }

  set = (param, value) => {
    this[param] = value;
  }

  redraw = () => {
    this.clear();
    this.draw();
  }

  draw = () => {

    this.drawPaths();

    this.drawToTrueCanvas();
  }

  drawToTrueCanvas = () => {
    const { id, virtualCanvas } = this;
    let canvas = document.getElementById(id);
    let ctx = canvas.getContext('2d');
    ctx.drawImage(virtualCanvas, 0, 0);
  }

  drawPaths = () => {
    const { paths, ctx } = this;
    for (let path of paths) {
      const { startX, startY, endX, endY, signal } = path;
      const fromX = startX * this.unitSize;
      let fromY = startY * this.unitSize;
      const toX = endX * this.unitSize;
      const toY = endY * this.unitSize;
      ctx.strokeStyle = "#cdcdcd"//"#87CEEB";//#B0C4DE
      ctx.lineWidth = 8;
      ctx.beginPath()
      ctx.moveTo(fromX, fromY);
      ctx.lineTo(toX, toY);
      ctx.stroke();
      ctx.closePath();

      const { width: lengthWidth, height: lengthHeight } = getTextWidthAndHeight(signal, { fontSize: 12 });
      ctx.font = `12px Arial`;
      ctx.lineWidth = 1
      ctx.fillStyle = `#000000`;
      const xLengthSpacing = Math.abs(toX - fromX) - lengthWidth;
      const lengthX = fromX + 0.5 * (xLengthSpacing > 0 ? xLengthSpacing : 0);
      const lengthY = fromY - 0.5 * lengthHeight;
      ctx.beginPath();
      ctx.fillText(signal, lengthX, lengthY);
      ctx.closePath();

    }
  }
}

const defaultColor = [
  "#D6EAF8", "#E6E6FA", "#FAFAD2", "#DBF0D6", "#F7E7CE", "#F8D7DA", "#FFF0F5", "#FDD5B1", "#FFF8E7", "#AFEEEE"
];
function getSchematicPcbColor(existColors) {
  let defaultIndex = existColors.length > defaultColor.length ? 0 : existColors.length;
  let color = defaultColor[defaultIndex], index = defaultIndex;

  while (existColors.includes(color)) {
    index += 1;
    if (index > defaultColor.length) {
      color = defaultColor[existColors.length];
      break;
    }
    color = defaultColor[defaultIndex];
  }
  return color;
}
export {
  ConnectionPlot,
  getSchematicPcbColor
}